import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../microServiceBase";
var PartnerNRDashboardUrlConfig = {
    Summary: URLConfig.config.apiBase +
        microService.dashboardService +
        "partnernr/summary",
    Header: URLConfig.config.apiBase +
        microService.dashboardService +
        "partnernr/header",
    Download: URLConfig.config.apiBase +
        microService.dashboardService +
        "partnernr/download",
};
export default PartnerNRDashboardUrlConfig;
